import * as React from "react";

export interface PlayerLinksProps {
  links: Link[];
}

export interface PlayerLinkProps {
  link: Link;
}

export interface Link {
  imageUrl: string;
  imageAltText: string;
  alias: string;
}

export const PlayerLink = ({ link }: PlayerLinkProps) => (
  <div className="player-link">
    <img src={link.imageUrl} className="link-badge" alt={link.imageAltText} />
    <span>{link.alias}</span>
  </div>
);

export const PlayerLinks = ({ links }: PlayerLinksProps) => {
  const playerLinkComponents = links.map((link, i) => (
    <PlayerLink key={i} link={link} />
  ));
  return <div className="player-link-box">{playerLinkComponents}</div>;
};



// WEBPACK FOOTER //
// ./src/Profile/PlayerLinks.tsx